<template>
    <div class="container">
        <!-- 面包屑导航 -->
        <div class="breadcrumb">
            <breadcrumb :breadcrumbConfig="dataList"></breadcrumb>
        </div>
        <!-- 查询客户列表 -->
        <div class="table">
            <div class="btnBox">
                <el-form :inline="true" ref="form" :model="queryForm" label-width="" size="mini">
                    <el-form-item>
                        <div class="input-with-select">
                            <span class="prepend-text">供应商分类</span>
                            <el-select v-model="queryForm.category" placeholder="请选择" clearable default-first-option>
                                <el-option v-for="(items, index) in dictionaries.supplier_category" :key="index"
                                    :label="items.dictName" :value="items.dictName"></el-option>
                            </el-select>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <div class="input-with-select">
                            <span class="prepend-text">供应商名称</span>
                            <el-input placeholder="请输入" v-model="queryForm.name"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <div class="input-with-select">
                            <span class="prepend-text">供应商编码</span>
                            <el-input placeholder="请输入" v-model="queryForm.supplierCode"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <div class="input-with-select">
                            <span class="prepend-text">联系电话</span>
                            <el-input placeholder="请输入" v-model="queryForm.contactNumber"></el-input>
                        </div>
                    </el-form-item>
                    <!-- 查询和重置按钮放在表单后面 -->
                    <el-form-item>
                        <el-button type="primary" size="mini" @click="searchEvent()"
                            v-on:keyup.enter="searchEvent">查询</el-button>
                        <el-button plain size="mini" @click="reset">重置</el-button>
                    </el-form-item>
                    <!-- 新增和导出按钮换行 -->
                    <el-form-item class="form-buttons" style="width: 100%;">
                        <div class="button-container">
                            <div class="button-group left-group">
                                <el-button @click="handleAdd" plain size="mini"
                                    v-if="parArray.indexOf('supplier-add') != -1"
                                    style="background-color: #fff; height: 24px; padding: 0 12px; line-height: 22px;">
                                    <span style="display: flex; align-items: center">
                                        新增供应商
                                    </span>
                                </el-button>

                                <!-- 导出下拉菜单 -->
                                <el-dropdown @command="handleExportCommand"
                                    v-if="parArray.indexOf('supplier-export') != -1">
                                    <el-button plain size="mini"
                                        style="height: 24px; padding: 1px 12px; line-height: 22px;">
                                        导出<i class="el-icon-arrow-down el-icon--right"></i>
                                    </el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item command="exportAll">
                                            导出列表
                                        </el-dropdown-item>
                                        <el-dropdown-item :disabled="!hasSelection" command="exportSelected"
                                            :class="{ 'is-disabled': !hasSelection }">
                                            导出本页勾选的数据
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <div style="padding: 0 10px;background-color: #fff;margin: 0 -10px;" v-loading="loading">
                <lb-table v-horizontal-scroll='"always"' border :column="columns" align="center" :data="tableData.list"
                    pagination :total="page.totalNum" layout="total, sizes, prev, pager, next, jumper"
                    :page-sizes="[5, 10, 20, 30, 50, 200]" :current-page.sync="page.currentPage"
                    :page-size="page.pageSize" @size-change="handleSizeChange" @p-current-change="handleCurrentChange"
                    @refresh="fetchData" :orderStatistics="page.totalNum" statisticText="当前列表统计总供应商数"
                    @selection-change="handleSelectionChange">
                </lb-table>
            </div>
        </div>
        <supplier-dialog :visible="dialogVisible" :type="dialogType" :form-data="formLabel"
            :supplier-names="supplierNames" :settlement-options="dictionaries.goods_type" :remote-method="remoteSMethod"
            @update:visible="dialogVisible = $event" @submit="handleSupplierSubmit"
            @closed="resetForm"></supplier-dialog>
    </div>
</template>

<script>
import vueEasyPrint from "vue-easy-print";
import breadcrumb from "@/components/breadcrumb.vue";
import * as imageConversion from 'image-conversion';
import LbTable from '@/pages/purchase/components/lb-table/lb-table'
import moment from 'moment';
import SupplierDialog from './add.vue'; // 引入子组件
export default {
    components: {
        vueEasyPrint, breadcrumb, LbTable, moment, SupplierDialog
    },
    data() {
        // 添加供应商表单验证规则
        const validateSupplierName = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请输入供应商名称'));
            } else {
                callback();
            }
        };
        return {
            dataList: {
                list: [
                    { title: '采购管理', type: 0, path: '' },
                    { title: '供应商列表', type: 1, path: '/purchase/supplierList' }
                ],
            },
            skus: [],
            brands: [],
            show3: false,
            imgDialogVisible: false,
            moreImg: "",
            queryForm: {
                category: "",
                name: "",
                contactNumber: "",
                supplierCode: "",
                platformType: null,
                sysUserId: null,
                pageNo: 1,
                pageSize: 10
            },
            dialogVisible: false, // 弹框显示控制
            dialogType: 'add', // 弹框类型: add-新增, edit-编辑
            pageNo: 1,
            pageSize: 10,
            brandselect: [],
            options: [],
            upplier: [],
            mulvaltipleSelection: [], // 当前页勾选的数据
            fileListImg: [],
            supplierNames: [],
            goodNames: [],
            goodsObj: [],
            dictionaries: { // 字典数据
                settlement_period: [], // 结算期限
                supplier_category: [], // 供应商分类
                goods_type: [], // 商品类型
            },
            brandId: '',

            parArray: [], // 权限数组
            loading: false,
            exportLoading: false, // 单独控制导出加载状态
            // 表单数据
            formLabel: {
                id: null,
                name: '',
                category: '',
                contactPerson: '',
                contactNumber: '',
                email: '',
                settlementPeriod: '',
                creditLimit: null,
                invoiceHeader: '',
                bankName: '',
                bankAccountNumber: '',
                address: '',
                remarks: '',
                supplierCode: ''
            },
            page: {
                pageNo: 1,
                pageSize: 10,
                totalNum: 0
            },
            tableData: {
                list: [],
                totalNum: 0
            },
            // 表单验证规则
            rules: {
                supplierName: [
                    { required: true, validator: validateSupplierName, trigger: 'blur' }
                ]
            },
            columns: [
                {
                    type: 'selection',
                    width: '30',
                    selectable: (row, index) => {
                        return true;
                    }
                },
                {
                    label: '序号', prop: 'index', width: '50',
                    render: (h, scope) => {
                        const index = (this.page.currentPage - 1) * this.page.pageSize + scope.$index + 1;
                        return h('div', index);
                    }
                },
                { label: '供应商名称', prop: 'name', width: '100' },
                { label: '供应商编码', prop: 'supplierCode', minWidth: '150' },
                { label: '供应商分类', prop: 'category', minWidth: '150' },
                {
                    label: '联系人', prop: 'contactPerson', minWidth: '120',
                },
                { label: '联系号码', prop: 'contactNumber', minWidth: '120' },
                {
                    label: '采购数量', prop: 'purchaseQuantity', width: '120',
                    render: (h, scope) => {
                        return (
                            <div class='ellipsis2' title={scope.row.purchaseQuantity}>{scope.row.purchaseQuantity ? scope.row.receiver : "-"}</div>
                        )
                    }
                },
                {
                    label: '退货数量', prop: 'returnQuantity', minWidth: '120',
                },
                {
                    label: '开户银行及账号',
                    prop: 'bankName',
                    width: '200', // 调整宽度以适应两个字段
                    render: (h, scope) => {
                        return (
                            <div>
                                <div class='ellipsis2' title={scope.row.bankName}>{scope.row.bankName || '-'}</div>
                                <div class='ellipsis2' title={scope.row.bankAccountNumber}>{scope.row.bankAccountNumber || '-'}</div>
                            </div>
                        );
                    }
                },
                {
                    label: '供应商地址', prop: 'address', width: '180',
                    render: (h, scope) => {
                        return (
                            <div class='align-center'>
                                {scope.row.address ? scope.row.address : '-'}
                            </div>
                        )
                    }
                },
                {
                    label: '创建时间', prop: 'createdTime', minWidth: '150',
                    render: (h, scope) => {
                        return h(
                            'div', this.formatDateTime(scope.row.createdTime)
                        )
                    }
                },
                {
                    label: '修改时间', prop: 'updatedTime', minWidth: '150',
                },
                {
                    label: '操作',
                    prop: 'orgName',
                    minWidth: '150',
                    fixed: "right",
                    render: (h, scope) => {
                        return (
                            <div style="display:flex;justify-content:center">
                                <el-button type="text" style="color:#409EFF;margin-right:8px"
                                    v-if="parArray.indexOf('supplier-edit') != -1"
                                    onClick={() => { this.handleEdit(scope.row) }}>
                                    查看/编辑
                                </el-button>
                                <el-button type="text" style="color:#F56C6C"
                                    v-if="parArray.indexOf('supplier-delete') != -1"
                                    onClick={() => { this.handleDelete(scope.row) }}>
                                    删除
                                </el-button>
                            </div>
                        )
                    }
                }
            ],
        };
    },

    computed: {
        // 计算弹窗标题
        dialogTitle() {
            const titles = {
                'add': '新增供应商',
                'edit': '编辑供应商',
            };
            return titles[this.dialogType];
        },
        // 是否有选中的数据
        hasSelection() {
            return this.mulvaltipleSelection && this.mulvaltipleSelection.length > 0;
        }
    },

    created() {
        // 权限设定判断（兼容采购订单的写法，并增强健壮性）
        try {
            const limitRaw = sessionStorage.getItem('limit');
            if (limitRaw) {
                const limits = typeof limitRaw === 'string' ? JSON.parse(limitRaw) : limitRaw;
                const tree = (limits && limits.buttonTreeDto) ? limits.buttonTreeDto : [];
                // 优先匹配供应商列表对应的菜单编码，支持多个可能的菜单编码
                const targetMenuCodes = ['purchaser'];
                console.log('供应商权限设定:', targetMenuCodes);
                let buttonList = [];
                const targetNode = tree.find(it => targetMenuCodes.includes(it.menuCode));
                if (targetNode && Array.isArray(targetNode.buttonList)) {
                    buttonList = targetNode.buttonList;
                } else {
                    // 兜底：合并所有按钮码
                    tree.forEach(it => {
                        if (Array.isArray(it.buttonList)) {
                            buttonList = buttonList.concat(it.buttonList);
                        }
                    });
                }
                // 去重写入 parArray
                const codes = (buttonList || []).map(b => b.code).filter(Boolean);
                this.parArray = Array.from(new Set(codes));
                console.log('供应商权限数组:', this.parArray);
            }
        } catch (e) {
            console.warn('权限解析失败:', e);
            this.parArray = [];
        }
        this.brandSelectBox();
        this.brandSelect();
        this.listAxios();
        this.upplierAxios();

        let _this = this;
        document.onkeydown = function (e) {
            let key = window.event.keyCode;
            if (key == 13) {
                _this.searchEvent();
            }
        };
        // 批量获取字典数据
        this.getMultipleDictionaries(['goods_type', 'supplier_category'])
    },
    beforeRouteLeave(to, form, next) {
        document.onkeydown = null;
        next();
    },
    methods: {
        // 处理表格选择变化
        handleSelectionChange(selection) {
            this.mulvaltipleSelection = selection;
        },

        // 处理导出命令
        handleExportCommand(command) {
            if (command === 'exportAll') {
                this.exportAllData();
            } else if (command === 'exportSelected') {
                if (!this.hasSelection) {
                    this.$message.warning('请先勾选要导出的数据');
                    return;
                }
                this.exportSelectedData();
            }
        },

        // 导出所有数据（包括翻页）
        exportAllData() {
            this.exportLoading = true;
            const exportParams = {
                sysUserId: sessionStorage.getItem('user_id') ? parseInt(sessionStorage.getItem('user_id')) : null,
                platformType: this.queryForm.platformType || 0,
                category: this.queryForm.category,
                name: this.queryForm.name,
                contactNumber: this.queryForm.contactNumber,
                supplierCode: this.queryForm.supplierCode,
                // 关键：不传递ids参数，让后端返回所有符合条件的数据
                ids: [],
                // 设置大页码来获取所有数据
                pageNo: 1,
                pageSize: 100000
            };

            // 清理空参数
            Object.keys(exportParams).forEach(key => {
                if (exportParams[key] === '' || exportParams[key] === null || exportParams[key] === undefined) {
                    delete exportParams[key];
                }
            });

            this.$api.srmSupplierExport(exportParams).then((res) => {
                this.exportLoading = false;
                if (res.code == 0) {
                    this.downloadlink(res.data);
                    this.$message.success('导出列表成功');
                } else {
                    this.$message.error(res.message || '导出失败');
                }
            }).catch((error) => {
                this.exportLoading = false;
                this.$message.error('导出失败，请重试');
                console.error('Export error:', error);
            });
        },

        // 导出本页勾选数据
        exportSelectedData() {
            this.exportLoading = true;
            const exportParams = {
                sysUserId: sessionStorage.getItem('user_id') ? parseInt(sessionStorage.getItem('user_id')) : null,
                platformType: this.queryForm.platformType || 0,
                category: this.queryForm.category,
                name: this.queryForm.name,
                contactNumber: this.queryForm.contactNumber,
                supplierCode: this.queryForm.supplierCode,
                // 只导出勾选的数据
                ids: this.mulvaltipleSelection.map(item => item.id),
                exportAll: false
            };

            this.$api.srmSupplierExport(exportParams).then((res) => {
                this.exportLoading = false;
                if (res.code == 0) {
                    this.downloadlink(res.data);
                    this.$message.success('导出本页勾选数据成功');
                } else {
                    this.$message.error(res.message || '导出失败');
                }
            }).catch((error) => {
                this.exportLoading = false;
                this.$message.error('导出失败，请重试');
                console.error('Export error:', error);
            });
        },

        // 下载链接方法
        downloadlink(url) {
            if (!url) {
                this.$message.error('下载链接为空');
                return;
            }

            const link = document.createElement('a');
            link.href = url;
            link.target = '_blank';
            link.download = '供应商列表.xlsx';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },


        // 新增供应商
        handleAdd() {
            if (this.parArray.indexOf('supplier-add') == -1) {
                this.$message.warning("您没有权限新增供应商");
                return;
            }

            this.dialogType = 'add';
            this.resetForm();
            this.dialogVisible = true;
        },

        // 编辑/查看供应商
        handleEdit(row) {
            if (this.parArray.indexOf('supplier-edit') == -1) {
                this.$message.warning("您没有权限编辑供应商");
                return;
            }
            this.dialogType = 'edit'; // 默认进入查看模式
            this.fillFormData(row);
            this.dialogVisible = true;
        },

        //处理供应商表单提交
        handleSupplierSubmit(formData) {
            if (this.dialogType === 'add') {
                this.addSupplier(formData);
            } else if (this.dialogType === 'edit') {
                this.updateSupplier(formData);
            }

        },

        // 新增供应商
        addSupplier(formData) {
            this.$api.srmSupplierAdd(formData).then(res => {
                if (res.code === 0) {
                    this.$message.success('新增成功');
                    this.dialogVisible = false;
                    this.listAxios();
                } else {
                    this.$message.error(res.message);
                }
            })
        },

        // 更新供应商
        updateSupplier(formData) {
            this.$api.srmSupplierEdit(formData)
                .then(res => {
                    if (res.code === 0) {
                        this.$message.success('更新成功');
                        this.dialogVisible = false;
                        this.listAxios();
                    } else {
                        this.$message.error(res.message);
                    }
                })
        },

        // 删除供应商
        handleDelete(row) {
            if (this.parArray.indexOf('supplier-delete') == -1) {
                this.$message.warning("您没有权限删除供应商");
                return;
            }
            this.$confirm('确定要删除该供应商吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteSupplier(row.id);
            }).catch(() => {
                this.$message.info('已取消删除');
            });
        },

        // 填充表单数据
        fillFormData(row) {
            this.formLabel = {
                id: row.id,
                supplierCode: row.supplierCode,
                name: row.name || row.supplierName,
                category: row.category,
                contactPerson: row.contactPerson || row.linkName,
                contactNumber: row.contactNumber || row.phone,
                email: row.email,
                settlementPeriod: row.settlementPeriod,
                creditLimit: row.creditLimit,
                invoiceHeader: row.invoiceHeader,
                bankName: row.bankName,
                bankAccountNumber: row.bankAccountNumber,
                address: row.address || row.supplierAddress,
                remarks: row.remarks
            };
        },

        // 新增重置表单
        resetForm() {
            this.formLabel = {
                id: null,
                name: '',
                category: '',
                contactPerson: '',
                contactNumber: '',
                email: '',
                settlementPeriod: '',
                creditLimit: null,
                invoiceHeader: '',
                bankName: '',
                bankAccountNumber: '',
                address: '',
                remarks: '',
                supplierCode: ''
            };
        },

        // 删除供应商
        deleteSupplier(id) {
            this.$api.srmSupplierRemove({ ids: [id] })
                .then(res => {
                    if (res.code === 0) {
                        this.$message.success('删除成功');
                        this.listAxios();
                    } else {
                        this.$message.error(res.message);
                    }
                })
                .catch(err => {
                    this.$message.error('删除失败');
                    console.error(err);
                });
        },

        // 添加时间格式化方法
        formatDateTime(dateTimeStr) {
            if (!dateTimeStr) return '';
            return moment(dateTimeStr).format('YYYY-MM-DD HH:mm:ss');
        },

        handleType(val) {
            for (let i = 0; i < this.dictionaries.goods_type.length; i++) {
                if (this.dictionaries.goods_type[i].dictId == val) {
                    return this.dictionaries.goods_type[i].dictName
                }
            }
        },
        fetchData() {
            this.listAxios();
        },

        // 批量获取字典数据
        getMultipleDictionaries(types) {
            types.forEach(type => {
                this.getDictionaries(type)
            })
        },

        // 获取字典数据
        getDictionaries(type) {
            if (type && this.dictionaries[type].length > 0) { return }
            const params = { groupId: type }
            this.$api.dictionaries(params).then((res) => {
                this.dictionaries[type] = res.data
            }).catch((err) => {
                console.log(err)
            })
        },
        tpPrintJS() {
            if (this.mulvaltipleSelection.length < 1) {
                this.$message.warning("请选择");
                this.value = "";
                return;
            }
            this.$refs.easyPrint.print();
        },
        getGoodNames(n) {
            this.axios
                .post(
                    "/goods/goods/getGoodsIds",
                    {
                        pageNo: 1,
                        pageSize: 200000,
                        title: n,
                        type: this.formLabel.type,
                    },
                    {
                        headers: {
                            isLoading: false,
                        },
                    }
                )
                .then((res) => {
                    this.goodsObj = res.data;
                    this.goodNames = res.data.map((item) => item.name);
                });
        },
        imgUpload(fileObj) {
            let length = this.fileListImg.length;
            let formData = new FormData();
            formData.append("file", fileObj.file);

            let config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            };
            if (length <= 20) {
                this.axios
                    .post(
                        "/sys/v1/common/upload/files?pathName=internalSystem",
                        formData,
                        config,
                        {
                            headers: {
                                isLoading: false,
                            },
                        }
                    )
                    .then((res) => {
                        if (res.code == 0) {
                            // this.imageUrl = res.data.url;
                            let obj = {
                                img: res.data.url,
                                creattime: new Date().toLocaleDateString(),
                            };
                            this.fileListImg.push(obj);
                        } else {
                            this.$message.error(res.message);
                        }
                    });
            } else {
                this.$message.warning("图片条数不能超过20条");
            }
        },
        test(file, fileList) {
            this.$message.warning(
                "图片最多10张,现在已上传" + this.fileListImg.length + "张"
            );
        },
        goodNameSelect(e) {
            let goodObj = this.goodsObj.find((res) => res.name == e);
            this.formLabel.goodName = e;
            console.log(goodObj);
            let data = {
                id: goodObj.id
            }
            this.axios.post("/goods/goods/getSkuList", data).then((res) => {
                if (res.code == 0) {
                    this.skus = res.data.skuList;
                    this.formLabel.brand = res.data.brandName
                    this.brandId = res.data.brandId
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        remoteMethod(e) {
            this.getGoodNames(e);
        },
        /**
        * @name: 选择商品类型触发
        * @test: test font
        * @msg:
        * @param {*} e:回调选择的value
        * @return {*}
        */
        onChange(e) {
            this.formLabel.type = e;
            this.$set(this.formLabel, "goodName", "");
            this.goodNames = [];
        },
        remoteSMethod(e) {
            this.axios
                .post("/order/v1/purchase/supplier/purchaseSupplierList", {
                    pageNo: 1, //第几页
                    pageSize: 20000, //一页多少条
                    supplierStatus: 1, //	未确认列表1 或者是 确认列表 2
                    supplierName: e,
                })
                .then((res) => {
                    this.supplierNames = res.data.list.map((i) => i.supplierName);
                    this.supplierObjs = res.data.list;
                });
        },
        beforeUploadImg(file) {
            return new Promise((resolve, reject) => {
                let _URL = window.URL || window.webkitURL;
                let isLt2M = file.size / 1024 / 1024 > 4; // 判定图片大小是否小于4MB
                // 这里需要计算出图片的长宽
                let img = new Image();
                img.onload = function () {
                    file.width = img.width; // 获取到width放在了file属性上
                    file.height = img.height; // 获取到height放在了file属性上
                    let valid = img.width > 10000; // 图片宽度大于2000
                    // console.log(11, file)
                    // 这里我只判断了图片的宽度,compressAccurately有多个参数时传入对象
                    if (valid || isLt2M) {
                        imageConversion.compressAccurately(file, {
                            size: 400,
                            width: 2000,
                        })
                            .then((res) => {
                                // console.log(33, res)
                                resolve(res);
                                this.$message.success(
                                    "成功添加" + this.fileList.length + "张图片"
                                );
                            });
                    } else resolve(file);
                }; // 需要把图片赋值
                img.src = _URL.createObjectURL(file);
            });
        },
        //删除图片
        deleteImg(type, index) {
            if (!this.mulvaltipleSelection.length && !type) {
                this.$message.warning("还没选择哦!");
                return;
            }

            if (type == 1) {
                this.fileListImg.splice(index, 1);
                return;
            }

            this.mulvaltipleSelection.forEach((res) => {
                this.tableData.list.splice(
                    this.tableData.list.findIndex((i) => i.id == res.id),
                    1
                );
            });
            this.axios
                .post(
                    "order/v1/purchase/supplier/delPurchaseSupplier",
                    this.mulvaltipleSelection.map((res) => res.id),
                    {
                        headers: {
                            isLoading: false,
                        },
                    }
                )
                .then((res) => {
                    if (res.code == 0) {
                        this.listAxios();
                        this.$message.success("删除成功");
                    } else {
                        this.$message.error(res.message);
                    }
                });
        },
        exports() {
            if (this.parArray.indexOf('supplier-export') === -1) {
                this.$message.warning('您没有导出数据的权限');
                return;
            }
            this.download(
                "/order/v1/purchase/supplier/supplierExportExcel", this.mulvaltipleSelection.map(res => res.id))
        },
        handleSizeChange(e) {
            this.page.pageSize = e;
            this.listAxios();
        },
        handleCurrentChange(e) {
            this.page.currentPage = e;
            this.listAxios();
        },
        listAxios() {
            const params = {
                category: this.queryForm.category,
                name: this.queryForm.name,
                contactNumber: this.queryForm.contactNumber,
                supplierCode: this.queryForm.supplierCode,
                platformType: this.queryForm.platformType,
                sysUserId: this.queryForm.sysUserId,
                pageNo: this.page.currentPage,
                pageSize: this.page.pageSize
            }
            this.$api.srmSupplierPage(params).then((res) => {
                if (res.code == 0) {
                    this.tableData.list = res.data.list;
                    this.page.totalNum = res.data.totalNum; // 更新总条数

                }
            })
        },
        // 创建人下拉框
        upplierAxios() {
            this.axios
                .get("/order/v1/purchase/supplier/supplierCreatedByList")
                .then((res) => {
                    if (res.code == 0) {
                        this.upplier = res.data;
                    } else {
                        this.$message.error(res.message);
                    }
                });
        },
        handleSelectionChange(val) {
            this.mulvaltipleSelection = val;
        },

        // 查看图片
        seeImg(row) {
            if (row.supplierImage.split(',')[0]) {
                this.moreImg = row.supplierImage;
                this.imgDialogVisible = true;
            }
        },

        reset() {
            this.queryForm = {
                info: "",
                goodName: "",
                founder: "",
                address: "",
                brand: "",
                category: "",
                date: "",
            };
            this.tableData.pageNo = 1;
            this.tableData.pageSize = 10;
            this.listAxios();
        },
        searchEvent() {
            this.tableData.pageNo = 1;
            this.tableData.pageSize = 10;
            this.listAxios();
        },
        //** 品牌下拉 **//
        brandSelectBox() {
            const params = { pageNo: 1, pageSize: 999 }
            this.$api.brandCommList(params).then((res) => {
                this.brandselect = res.data.list
            }).catch((err) => {
                console.log(err)
            })
        },
        //** 品牌下拉 **//
        // 分类下拉框
        brandSelect() {
            this.axios.get("/order/comm/commodity/selectBrand").then((res) => {
                if (res.code == 0) {
                    this.options = res.data;
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        addCg() {
            let array = [];
            if (this.mulvaltipleSelection.length > 0) {
                for (let i in this.mulvaltipleSelection) {
                    array.push(this.mulvaltipleSelection[i].id);
                }

                this.$router.push({
                    name: "purchasingAdd",
                    query: {

                        ids: JSON.stringify(array),
                    },
                });
            } else {
                this.$message.warning("未选择供应商");
            }
        },
    },
};
</script>

<style scoped lang="scss">
/* 添加下拉菜单样式 */
.el-dropdown {
    margin-left: 10px;
}

.el-dropdown-menu {
    .is-disabled {
        cursor: not-allowed;
        color: #c0c4cc;
    }
}

.btnBox {
    padding: 10px 10px;
    display: flex;
    justify-content: space-between;
    background-color: #ffffff;
    margin: 0 -10px;

    /deep/ {
        .el-form-item__content {
            line-height: 1;
        }

        .el-input-group__prepend {
            width: 90px;
            padding: 0 12px 0 10px;
            box-sizing: border-box;

            .el-input__inner {
                padding: 0 10px 0 7px;
                text-align: left;
            }
        }

        .el-input__inner {
            padding: 0 8px 0;
            height: 24px;
            line-height: 24px;
            border-radius: 0;
            margin-bottom: 8px;
            width: 120px;
        }

        .group-con-form {

            .el-input--mini,
            .el-cascader--mini {
                width: 180px;
            }

            .el-input__inner {
                text-align: left;
                padding: 0 10px 0 8px;
                max-width: 180px;
            }
        }
    }
}

.input-with-select {
    display: flex;
    align-items: center;

    .prepend-text {
        width: 90px;
        flex-shrink: 0;
        background-color: #F5F7FA;
        border: 1px solid #DCDFE6;
        border-right: none;
        font-size: 12px;
        color: #909399;
        font-family: Arial;
        height: 24px;
        line-height: 22px;
        box-sizing: border-box;
        padding: 0 0 0 6px;
        border-radius: 4px 0 0 4px;
    }

    .select {
        border-radius: 0;
        line-height: 24px;

        .el-input__inner {
            border-radius: 0;
            padding: 0 8px 0 0;
            font-size: 12px;
            font-family: Arial;
            height: 24px !important;
        }

        .el-input__suffix {
            display: none;
        }

        .el-cascader__tags {
            flex-wrap: nowrap;
            cursor: pointer;
            justify-content: flex-end;
            right: 3px;

            .el-tag {
                margin: 0;
                padding: 0 1px;
                height: 18px;
                max-width: calc(100% - 3px);
            }

            .el-tag__close {
                display: none;
            }
        }
    }
}

.form-buttons {
    /deep/ .el-form-item__content {
        width: 100%;
    }
}

.button-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 10px;
}

.button-group {
    display: flex;
    gap: 10px;
    align-items: center;

    &.left-group {
        justify-content: flex-start;

        .el-button {
            height: 24px;
            padding: 0 12px;
            line-height: 22px;
            font-size: 12px;

            &.is-plain {
                background-color: #ffffff;
            }
        }
    }
}

// 确保表单项不会额外增加间距
.btnBox /deep/ .el-form-item {
    margin-bottom: 8px;
}

// 特别针对按钮表单项进行调整
.form-buttons /deep/ .el-form-item__content {
    line-height: normal;
}

/deep/.cell {
    color: #333;
}

.page {
    text-align: right;
    width: 100%;
    background: #f5f5f5;
    padding-right: 20px;
    position: fixed;
    bottom: 0px;
    right: 0px;
    z-index: 1000;

    span {
        font-size: 14px;
        color: #666;
        display: inline-block;
        margin-left: 10px;
    }

    .el-pagination {
        display: inline-block;
        vertical-align: middle;
    }
}

.add_supplier {
    /deep/ {
        .el-dialog__title {
            font-weight: 400;
            font-size: 16px;
            color: #333333;
        }
    }
}

.supplier {
    margin-top: 20px;

    /deep/.el-form-item__label {
        width: 100px;
        height: 30px;
        line-height: 30px;
    }

    /deep/.el-input,
    /deep/.el-input__inner {
        height: 30px;
        line-height: 30px;
    }

    /deep/.el-form-item {
        margin-bottom: 15px;
    }

    /deep/ {
        .el-textarea {
            width: 100%;
        }
    }

    /deep/.el-select {
        width: 100%;

        /deep/.el-input__icon {
            height: 30px;
            line-height: 30px;
        }
    }
}

.opt {
    color: rgb(65, 104, 231);
}

.opt:hover {
    cursor: pointer;
}

/deep/.el-dialog__body {
    padding: 0 25px;
}
</style>